import { render, staticRenderFns } from "./RewardPeriod.vue?vue&type=template&id=53874785"
import script from "./reward-period.ts?vue&type=script&lang=ts&external"
export * from "./reward-period.ts?vue&type=script&lang=ts&external"
import style0 from "./reward-period.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports